module.exports = __webpack_public_path__ + "static/media/Icon03.0e929eff.png";